export interface StoreProduct {
  id: number;
  name: string;
  category: string;
  price: number;
  originalPrice?: number;
  image: string;
  description: string;
  features: string[];
  badge?: string;
  inStock: boolean;
  unit: string;
  images?: string[];
  stock?: number | null;
  sku?: string;
}

export const storeCategories = [
  "All Products",
  "Kitchen Equipment",
  "HVAC & Ventilation",
  "Hospital & Pharmacy",
  "Food Processing",
  "Maintenance Plans",
  "Design Services",
];

export const storeProducts: StoreProduct[] = [
  {
    id: 1,
    name: "SS304 Commercial Worktop — Custom Size",
    category: "Kitchen Equipment",
    price: 8500,
    image: "https://isman.co.ke/api/search-image?v=2&query=professional%20stainless%20steel%20SS304%20commercial%20kitchen%20worktop%20counter%20gleaming%20brushed%20finish%20white%20studio%20background%20product%20photography%20clean%20industrial&width=600&height=450&seq=prod1&orientation=landscape",
    description: "Food-grade SS304 stainless steel worktop fabricated to your exact dimensions. Brushed No.4 finish. Welded-in splashback option available.",
    features: ["SS304 food-grade steel", "No.4 brushed finish", "TIG-welded seams", "HACCP compliant", "Custom sizes"],
    badge: "Best Seller",
    inStock: true,
    unit: "per linear metre",
  },
  {
    id: 2,
    name: "Exhaust Canopy Hood — 1200mm",
    category: "Kitchen Equipment",
    price: 12000,
    originalPrice: 14500,
    image: "https://isman.co.ke/api/search-image?v=2&query=stainless%20steel%20commercial%20kitchen%20exhaust%20hood%20canopy%20ventilation%201200mm%20product%20photography%20white%20background%20professional%20industrial%20SS304%20polished&width=600&height=450&seq=prod2&orientation=landscape",
    description: "1200mm wide SS304 wall-mounted exhaust canopy with integrated grease filters, perimeter lighting, and 600mm duct collar.",
    features: ["1200mm width", "Grease filter baffles", "LED strip lighting", "600mm duct collar", "Powder-coated frame"],
    badge: "Sale",
    inStock: true,
    unit: "per unit",
  },
  {
    id: 3,
    name: "2-Bay Pot Wash Sink — SS304",
    category: "Kitchen Equipment",
    price: 15500,
    image: "https://isman.co.ke/api/search-image?v=2&query=double%20bay%20stainless%20steel%20pot%20wash%20sink%20commercial%20kitchen%20SS304%20deep%20bowl%20drainboard%20professional%20product%20studio%20background%20white%20gleaming&width=600&height=450&seq=prod3&orientation=landscape",
    description: "Heavy-duty double-bowl pot wash sink with integral drainboard, knee-operated tap fittings, and adjustable legs. Depth 400mm.",
    features: ["2 x 500mm deep bowls", "Integral drainboard", "Knee-operated taps", "Adjustable legs", "BS EN standard"],
    inStock: true,
    unit: "per unit",
  },
  {
    id: 4,
    name: "Stainless Steel Kitchen Trolley",
    category: "Kitchen Equipment",
    price: 9500,
    image: "https://isman.co.ke/api/search-image?v=2&query=stainless%20steel%20kitchen%20utility%20trolley%20two%20shelves%20commercial%20restaurant%20professional%20product%20photography%20white%20background%20SS304%20brushed%20wheels%20modern&width=600&height=450&seq=prod4&orientation=landscape",
    description: "2-shelf SS304 utility trolley with 4 heavy-duty swivel castors (2 lockable). Ideal for food transport, plating, and waste collection.",
    features: ["SS304 construction", "2 solid shelves", "4 swivel castors", "2 lockable", "Pushbar included"],
    inStock: true,
    unit: "per unit",
  },
  {
    id: 5,
    name: "Split Air Conditioning Unit — 1.5HP",
    category: "HVAC & Ventilation",
    price: 45000,
    originalPrice: 52000,
    image: "https://isman.co.ke/api/search-image?v=2&query=modern%20split%20air%20conditioning%20unit%20indoor%20wall%20mounted%20white%20sleek%201.5HP%20commercial%20HVAC%20product%20photography%20clean%20background%20professional%20installation&width=600&height=450&seq=prod5&orientation=landscape",
    description: "1.5HP inverter split AC unit — supply, installation, and 1-year parts warranty. Suitable for offices, consultancy rooms, and retail spaces up to 20 m².",
    features: ["1.5HP inverter", "Energy-saving R32 refrigerant", "WiFi control", "Installation included", "1-year parts warranty"],
    badge: "Includes Install",
    inStock: true,
    unit: "per unit (supply + install)",
  },
  {
    id: 6,
    name: "Ducted Exhaust Fan — 250mm",
    category: "HVAC & Ventilation",
    price: 6800,
    image: "https://isman.co.ke/api/search-image?v=2&query=industrial%20ducted%20exhaust%20ventilation%20fan%20250mm%20commercial%20HVAC%20metal%20casing%20product%20photography%20white%20studio%20background%20professional%20air%20extraction&width=600&height=450&seq=prod6&orientation=landscape",
    description: "Heavy-duty 250mm duct inline fan for commercial kitchen, toilet, and server room extraction. IP44 rated. 1,200 m³/hr airflow.",
    features: ["250mm duct", "1,200 m³/hr", "IP44 rated", "Low noise 45dB", "Pre-wired plug"],
    inStock: true,
    unit: "per unit",
  },
  {
    id: 7,
    name: "Hospital Pharmacy Counter — SS316",
    category: "Hospital & Pharmacy",
    price: 35000,
    image: "https://isman.co.ke/api/search-image?v=2&query=hospital%20pharmacy%20dispensing%20counter%20stainless%20steel%20SS316%20modern%20medical%20facility%20white%20clean%20professional%20product%20custom%20fabricated%20dispensary&width=600&height=450&seq=prod7&orientation=landscape",
    description: "SS316 pharmacy dispensing counter with lockable drawers, pass-through window, and under-counter refrigeration bay. Custom width available.",
    features: ["SS316 marine grade", "Lockable drawers", "Pass-through window", "Refrigeration bay", "Cable management"],
    badge: "Custom Made",
    inStock: true,
    unit: "per 1200mm module",
  },
  {
    id: 8,
    name: "Sluice/Bedpan Washer Surround — SS316",
    category: "Hospital & Pharmacy",
    price: 18500,
    image: "https://isman.co.ke/api/search-image?v=2&query=hospital%20sluice%20room%20stainless%20steel%20SS316%20bedpan%20washer%20surround%20medical%20grade%20professional%20clean%20white%20fabricated%20wall%20panel&width=600&height=450&seq=prod8&orientation=landscape",
    description: "Full SS316 sluice room lining including wall panels, floor coving, and bedpan washer surround. Infection control compliant.",
    features: ["SS316 marine grade", "Full wall cladding", "Floor coving", "Drilled for plumbing", "Infection control compliant"],
    inStock: true,
    unit: "per standard sluice room",
  },
  {
    id: 9,
    name: "SS304 Mixing Tank — 200 Litres",
    category: "Food Processing",
    price: 25000,
    image: "https://isman.co.ke/api/search-image?v=2&query=stainless%20steel%20SS304%20food%20grade%20mixing%20tank%20200%20litres%20industrial%20food%20processing%20equipment%20white%20background%20professional%20product%20photography%20modern&width=600&height=450&seq=prod9&orientation=landscape",
    description: "200-litre SS304 mixing/blending tank with lid, bottom outlet valve, sight glass, and CIP spray ball. HACCP certified design.",
    features: ["200L capacity", "SS304 food grade", "CIP spray ball", "Bottom drain valve", "HACCP design"],
    badge: "HACCP Ready",
    inStock: true,
    unit: "per unit",
  },
  {
    id: 10,
    name: "Stainless Steel Flat-Bed Conveyor — 1m",
    category: "Food Processing",
    price: 32000,
    image: "https://isman.co.ke/api/search-image?v=2&query=stainless%20steel%20flat%20bed%20food%20conveyor%20belt%201%20metre%20industrial%20food%20processing%20SS304%20hygienic%20design%20product%20photography%20white%20studio%20modern&width=600&height=450&seq=prod10&orientation=landscape",
    description: "1-metre SS304 flat-belt food conveyor with variable speed drive. Belt width 400mm. Suitable for sorting, inspection, and packing lines.",
    features: ["1m length, 400mm belt", "Variable speed", "SS304 food safe", "Easy-clean belt", "CE marked motor"],
    inStock: true,
    unit: "per 1m section",
  },
  {
    id: 11,
    name: "Annual HVAC Maintenance Plan",
    category: "Maintenance Plans",
    price: 18000,
    originalPrice: 24000,
    image: "https://isman.co.ke/api/search-image?v=2&query=HVAC%20maintenance%20service%20plan%20technician%20engineer%20checking%20air%20conditioning%20unit%20professional%20Kenya%20Africa%20annual%20service%20contract%20commercial%20building&width=600&height=450&seq=prod11&orientation=landscape",
    description: "2 service visits per year for up to 4 AC units. Includes coil cleaning, refrigerant check, filter replacement, drain cleaning, and full electrical inspection.",
    features: ["2 visits per year", "Up to 4 AC units", "Coil & filter service", "Refrigerant check", "Written service report"],
    badge: "Best Value",
    inStock: true,
    unit: "per year (up to 4 units)",
  },
  {
    id: 12,
    name: "3D Kitchen Design & Engineering Package",
    category: "Design Services",
    price: 15000,
    image: "https://isman.co.ke/api/search-image?v=2&query=3D%20kitchen%20design%20blueprint%20AutoCAD%20rendering%20commercial%20restaurant%20kitchen%20layout%20professional%20engineering%20drawing%20modern%20top%20view%20technical%20plan&width=600&height=450&seq=prod12&orientation=landscape",
    description: "Full 3D AutoCAD design service for commercial kitchens. Includes workflow analysis, 3D renders, equipment schedule, and utility load drawings.",
    features: ["Full 3D AutoCAD model", "Workflow analysis", "Equipment schedule", "Utility load drawings", "KEBS-ready layout"],
    badge: "Design Service",
    inStock: true,
    unit: "per project",
  },
];
